import { createFileRoute } from '@tanstack/react-router'

import { PaymentReportScreen } from './-components/payment-report-screen.tsx'

export const Route = createFileRoute('/cs-tools/payment-report')({
  component: PaymentReportScreen
})
